// ==========================================================================
// DIG - Duffy Investment Group : content data (text taken from design drafts)
// NOTE: Images below are close-matching PLACEHOLDERS. Swap with the client's
// original photos (Craig Duffy portraits, BRW badge, office, etc.) when supplied.
// ==========================================================================

export const IMAGES = {
  // Client-supplied originals
  heroBusinessman: '/images/craig-portrait.jpg',
  executivePortrait: '/images/craig-portrait.jpg',
  golf: '/images/craig-hawke.jpg',
  businessmanRedTie: '/images/craig-portrait.jpg',
  dig7mThumb: '/images/dig-7m-acquisition-thumb.jpg',
  kalvinHero: '/images/kalvin-hero.jpg',
  kalvinProfile: '/images/kalvin-profile.jpg',
  seanHero: '/images/sean-hero.jpg',
  seanProfile: '/images/sean-profile.jpg',
  // Sector detail pages — exact assets from the client design drafts
  entHero: '/images/ent-hero.jpg',
  entContent: '/images/ent-content.jpg',
  entFocus: '/images/ent-focus.jpg',
  propHero: '/images/property-hero.jpg',
  propContent: '/images/property-content.jpg',
  gamingHero: '/images/gaming-hero.jpg',
  gamingContent: '/images/gaming-content.jpg',
  itHero: '/images/it-hero.jpg',
  itContent: '/images/it-content.jpg',
  prwebLogo: '/images/prweb-logo.png',
  // Client-supplied sector tiles (icon + title baked in)
  sectorVc: '/images/sector-vc.jpg',
  sectorIt: '/images/sector-it.jpg',
  sectorGaming: '/images/sector-gaming.jpg',
  sectorProperty: '/images/sector-property.jpg',
  sectorEntertainment: '/images/sector-entertainment.jpg',
  sydney: 'https://images.unsplash.com/photo-1561488111-5d800fd56b8a',
  circuit: '/images/investments-hero.jpg',
  reception: 'https://images.unsplash.com/photo-1758448656987-cfae6bf225e4',
  building: 'https://images.unsplash.com/photo-1624204386084-dd8c05e32226',
  network: 'https://images.unsplash.com/photo-1737505599162-d9932323a889',
  dice: 'https://images.unsplash.com/photo-1595744043037-68de3376ed59',
  concert: 'https://images.pexels.com/photos/30215324/pexels-photo-30215324.jpeg',
  newspapers: 'https://images.pexels.com/photos/12585773/pexels-photo-12585773.jpeg',
  pokerChips: 'https://images.unsplash.com/photo-1636583134257-b8a45fe61a83',
  cards: 'https://images.unsplash.com/photo-1622014402888-e78d0fd790d0',
  snooker: 'https://images.unsplash.com/photo-1668605048080-2ceacc3fa49f',
  stockChart: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3',
};

export const NAV = [
  { label: 'HOME', path: '/' },
  { label: 'ABOUT', path: '/about' },
  { label: 'OUR PEOPLE', path: '/our-people' },
  { label: 'OUR INVESTMENTS', path: '/our-investments' },
  { label: 'ALL NEWS', path: '/insights', footerLabel: 'All News' },
  { label: 'CONTACT', path: '/contact' },
];

export const HOME_PILLARS = [
  { icon: 'Globe', title: 'GLOBAL PRESENCE', text: 'Experience in over 22 countries worldwide.' },
  { icon: 'TrendingUp', title: 'PROVEN TRACK RECORD', text: 'Delivering value through disciplined investment strategies.' },
  { icon: 'Users', title: 'LOCAL EXPERTISE', text: 'Local knowledge. Global vision. Better outcomes.' },
];

export const BRW = {
  headline: 'RECOGNISED. RESPECTED. TRUSTED.',
  name: 'Craig Duffy – BRW Top 100 Richest Australians.',
  sub: "Listed among Australia's Top 100 Richest (Business Review Weekly).",
};

// ---- About ----
export const ABOUT_APPROACH = [
  { icon: 'Search', title: 'IDENTIFY', text: 'We identify and research opportunities with strong potential for long term value creation.' },
  { icon: 'Users', title: 'PARTNER', text: 'We guide and mentor each investment, working closely with management teams.' },
  { icon: 'TrendingUp', title: 'COMMERCIALISE', text: 'We help unlock full potential and drive successful commercial outcomes.' },
];

// ---- Our People : key highlights ----
// Craig Duffy's key investment highlights — reproduced word-for-word from the client's
// supplied biography. Do not rewrite, summarise or abbreviate.
export const PEOPLE_HIGHLIGHTS = [
  { icon: 'TrendingUp',
    text: "Founding Director/Lead seed investor and CEO of one of Australia's fastest growing and largest IT companies having successfully raised capital and floated the company on the Australian Stock Exchange in the early 2000s. Within three years of establishing the company he grew the firm from zero to a company worth $150M in market capitalization. It was also rated by The Australian Financial Review as the most successful IPO float of its year on the Australian Stock Exchange (ASX)." },
  { icon: 'Users',
    text: "Mr. Duffy achieved all this by the age of 34. Under Mr. Duffy's direction as CEO, the company grew from 5 employees in 2001 to over 200 employees with 9 offices in 7 countries within two years. He diversified into insurance and at one stage had globally recognized insurance industry software that had AUD$39M spent on its development." },
  { icon: 'Handshake',
    text: "Mr. Duffy orchestrated a JV and later full divestment of the technology to a multi-billion dollar Australian based company, which featured as one of Australia's top 20 companies." },
  { icon: 'Landmark',
    text: 'He diversified into finance and a broking division that at its peak was financing $500 million in Australian home loans per year.' },
  { icon: 'Globe',
    text: "Mr. Duffy was chief software architect and Managing Director on two of Australia's most successful IT projects of their type within the stock exchange software platform, portfolio management and data dissemination industries with licenses signed by over 20 stock exchanges in 20 countries globally with over 30,000 customers." },
  { icon: 'Trophy',
    text: "As a result of the above, Mr. Duffy's company was featured in Business Review Weekly's (BRW) fastest growing Australian companies list. Mr. Duffy himself has also been featured for three years running in BRW's young Australian entrepreneur's list which features Australia's most successful self-made businessmen under the age of 40." },
  { icon: 'UserRound',
    text: "Prior to the above, Mr. Duffy has been one of Australia's most successful sportsmen having been a professional snooker and pool player. He has won multiple Queensland Open Championships, 4 Australian Open Championships and placed third in the World Championships two years running, ranking him number 3 in the world at the time. He is a self made, fully committed entrepreneurial businessmen with a 'can do' attitude and a highly successful business history" },
];

export const PEOPLE = [
  {
    id: 'craig', name: 'Craig Duffy', role: 'Executive Chairman',
    heroType: 'statement', heroImg: 'heroBusinessman', heroTinted: true,
    profileHeading: 'Mr Craig Duffy', profileHeadingSerifCaps: false,
    profileSubHeading: 'Executive Chairman',
    profileImg: 'golf', profileCaption: 'Mr Craig F Duffy with Mr Bob Hawke,\n23rd Prime Minister of Australia.',
    bio: [
      'Mr. Duffy is Founder and Executive Chairman of Duffy Investment Group. He is a businessman and entrepreneur who has successfully established and run a diverse range of multi-million dollar businesses in 7 countries around the world.',
      'These include Information Technology, Finance, Entertainment and property investment. He is highly regarded as a business builder and capital raising specialist.',
    ],
    showHighlights: true, showStats: true,
  },
  {
    id: 'kalvin', name: 'Kalvin Duffy', role: 'Managing Director',
    heroType: 'name', heroImg: 'kalvinHero', heroTinted: false,
    profileHeading: 'Kalvin Duffy', profileHeadingSerifCaps: false,
    profileImg: 'kalvinProfile', profileCaption: '',
    bio: [
      "Taking over as Managing Director of one of Australia's most famous and longest-running adult venues of its type, Kalvin now oversees a team of more than 150 staff.",
      'Kalvin undertook extensive tertiary studies and honed his practical skills within the restaurant industry, working with the well-respected Gennari Group.',
      'He brings more than 10 years of experience in hardworking, fast-paced environments, guided by the passion and high standards of Duffy Investment Group founder and Executive Chairman Craig F Duffy.',
    ],
    showHighlights: false, showStats: false,
  },
  {
    id: 'sean', name: 'Sean Duffy', role: 'Director of Marketing',
    heroType: 'name', heroImg: 'seanHero', heroTinted: false,
    profileHeading: 'Sean Duffy', profileHeadingSerifCaps: false,
    profileImg: 'seanProfile', profileCaption: '',
    bio: [
      'Young, hungry, hardworking, intelligent and passionate best describes Sean. Having recently taken over the marketing directives within the group he has a diverse range of skills from amusements, gaming and sales.',
      'An energetic addition to the team.',
    ],
    showHighlights: false, showStats: false,
  },
];

export const PEOPLE_STATS = [
  { icon: 'Globe', value: '7', label: 'COUNTRIES WORLDWIDE' },
  { icon: 'Users', value: '20+', label: 'SUCCESSFUL INVESTMENTS' },
  { icon: 'TrendingUp', value: '$500M+', label: 'FINANCING AT PEAK' },
  { icon: 'Handshake', value: '30,000+', label: 'CUSTOMERS GLOBALLY' },
];

// ---- Our Investments ----
export const INVEST_APPROACH = [
  { icon: 'Sprout', title: 'EARLY STAGE', text: 'Passive early stage start ups, angel investments and seed funding options.' },
  { icon: 'Handshake', title: 'STRATEGIC PARTNERSHIPS', text: 'Joint ventures and strategic partnerships to accelerate growth.' },
  { icon: 'TrendingUp', title: 'GROWTH & EXPANSION', text: 'Growth capital to scale operations and expand into new markets.' },
  { icon: 'Landmark', title: 'ACQUISITIONS', text: 'Outright takeovers and control investments in quality businesses.' },
  { icon: 'Target', title: 'EXIT STRATEGIES', text: 'Pre IPO, trade sales and other liquidity options to deliver strong returns.' },
];

export const INVEST_SECTORS = [
  { icon: 'Handshake', mIcon: 'Sprout', title: 'VENTURE CAPITAL', short: 'VENTURE CAPITAL', text: 'Backing innovative entrepreneurs and high-potential businesses.', img: 'sectorVc', to: '/our-investments' },
  { icon: 'Cpu', mIcon: 'Monitor', title: 'INFORMATION TECHNOLOGY', short: 'IT', text: 'Investing in technology leaders shaping the future.', img: 'sectorIt', to: '/information-technology' },
  { icon: 'Dices', mIcon: 'Dices', title: 'GAMING', short: 'GAMING', text: 'Backing leading gaming and interactive entertainment ventures.', img: 'sectorGaming', to: '/gaming' },
  { icon: 'Building2', mIcon: 'Landmark', title: 'PROPERTY', short: 'PROPERTY', text: 'Strategic property investments across residential, commercial and development.', img: 'sectorProperty', to: '/property' },
  { icon: 'Music', mIcon: 'Users', title: 'ENTERTAINMENT', short: 'ENTERTAINMENT', text: 'Investing in content, media and entertainment opportunities.', img: 'sectorEntertainment', to: '/entertainment' },
];

export const INVEST_STATS = [
  { icon: 'Globe', value: '22+', label: 'COUNTRIES OF INVESTMENT EXPERIENCE', mValue: '22+', mLabel: 'COUNTRIES' },
  { icon: 'Building2', value: 'DIVERSE', label: 'MULTI-SECTOR INVESTMENT PORTFOLIO', mValue: 'DIVERSE', mLabel: 'PORTFOLIO' },
  { icon: 'TrendingUp', value: 'PROVEN TRACK RECORD', label: 'DELIVERING STRONG RISK-ADJUSTED RETURNS', mValue: 'PROVEN', mLabel: 'RETURNS' },
  { icon: 'Users', value: 'HANDS-ON APPROACH', label: 'ACTIVE PARTNERS IN OUR INVESTEE COMPANIES', mValue: 'HANDS-ON', mLabel: 'APPROACH' },
];

export const VALUE_FOOTER = [
  { icon: 'Users', label: 'Hands-on Approach' },
  { icon: 'TrendingUp', label: 'Proven Track Record' },
  { icon: 'Building2', label: 'Diverse Industry Experience' },
  { icon: 'Target', label: 'Long-Term Focus' },
];

// ---- Insights ----
export const INSIGHTS_FILTERS = ['ALL NEWS'];

// ---- All News ----
// AUTHORITY SOURCE: http://duffyig.com/blog.php — titles, descriptions and links are reproduced
// from that page in that order. Do not reword. Some articles carry 2-3 story links.
export const INSIGHTS = [
  { day: '10', month: 'NOV', year: '2015',
    title: 'GOLD COAST BULLETIN NOVEMBER 10',
    text: 'Hollywood Showgirls celebrates 11th birthday: Owner Craig Duffy shares the highlights',
    img: null,
    links: ['http://www.goldcoastbulletin.com.au/lifestyle/hollywood-showgirls-celebrates-11th-birthday-owner-craig-duffy-shares-the-highlights/news-story/73a482c0f688258919c146d8055a09fe'] },

  { day: '30', month: 'OCT', year: '2015',
    title: 'DIG COMPLETES $7M PROPERTY ACQUISITION',
    text: "Snooker King Duffy calls shots and snaps up venue's home for $7.2M",
    img: 'dig7mThumb', imgLink: '/images/dig-7m-acquisition-full.png',
    links: ['/images/dig-7m-acquisition-full.png'] },

  { day: '20', month: 'OCT', year: '2015',
    title: 'DIG OFFER TO FINANCE LOCAL GOVERNMENT',
    text: 'DIG offer to finance local Government infrastructure project',
    img: null,
    links: [
      'https://www.goldcoastbulletin.com.au/news/gold-coast/hollywood-showgirls-boss-yet-to-hear-if-council-keen-on-offer-to-ease-lack-of-public-toilets-in-surfers/news-story/8d811cc12c753ac0a2a47a706d7861c6',
      'https://www.goldcoastbulletin.com.au/news/strip-club-owner-offers-permanent-solootion-for-public-toilets-in-surfers-paradise/news-story/32656c02f8de8086836d32ed5c81a6e0',
      'https://www.goldcoastbulletin.com.au/news/gold-coast/openair-urinals-in-surfers-paradise-look-set-to-return-as-council-plans-permanent-solution/news-story/d5555ce01076faf229538cf1c7c20bc8',
    ] },

  { day: '15', month: 'JAN', year: '2015',
    title: 'FINAL TABLE',
    text: 'Jan 2015 – DIG Poker game inventor makes final table 2 years running at prestigious Aussie Millions Poker',
    img: 'pokerChips',
    links: [
      'https://www.pokernews.com/tours/aussie-millions/2016-aussie-millions/event-1/chips.134563.htm',
      'https://pokerdb.thehendonmob.com/event.php?a=r&n=251139',
    ] },

  { day: '13', month: 'DEC', year: '2015',
    title: 'GOLD COAST BULLETIN DECEMBER 13',
    text: 'Hollywood Showgirls owner Craig Duffy has celebrated 10 years of his Surfers Paradise night-life icon',
    extra: 'It\u2019s 9.30pm on Thursday a week ago and Craig Duffy sits at the marble-topped bar inside his plush strip joint or \u2014 as the Hollywood Showgirls catchcry says \u2014 \u201Cnightclub with a difference!\u201D.',
    img: null,
    links: ['https://www.goldcoastbulletin.com.au/business/gold-coast-business/hollywood-showgirls-owner-craig-duffy-celebrates-10th-birthday-of-his-surfers-paradise-strip-club/news-story/323faba1e2d6b21cdd3d6de6677554e4'] },

  { day: '12', month: 'JAN', year: '2014',
    title: 'FINAL TABLE',
    text: 'Jan 2014 - DIG Bet the Flop patented Poker game inventor Craig Duffy makes final table at Aussie millions Poker',
    img: 'cards',
    links: ['http://www.pokerasiapacific.com/2014-aussie-millions-event-7-live-updates41324.html'] },

  { day: '—', month: 'AUG', year: '2009',
    title: 'LEADING THE FIELD AT JUPITERS CASINO',
    text: 'Aug 2009 - Bet The Flop DIG Poker game inventor leads massive Poker field on day 1 at Jupiter\u2019s casino',
    img: 'dice',
    links: ['https://www.pokerstars.com/poker/learn/news/anzpt-queensland-duffys-big-day-out-at-j-055223/'] },

  { day: '24', month: 'FEB', year: '2004',
    title: 'DIG $8M SELL DOWN OF SHARES',
    text: 'DIG $8m sell down of shares to boost liquidity in ASX listed technology company',
    img: 'stockChart',
    links: ['https://www.theage.com.au/business/for-some-too-many-ions-in-the-fire-20040224-gdxdd2.html'] },

  { day: '04', month: 'NOV', year: '2006',
    title: 'CRAIG DUFFY NAMED Australia\u2019s No.1 and 16th BEST POOL PLAYER OF ALL TIME',
    text: 'DIG founder Craig Duffy named best snooker and pool player of all time from Australia',
    img: 'snooker',
    links: ['https://forums.azbilliards.com/threads/wpc-all-time-rankings.45451/'] },
];

// ---- Contact ----
export const CONTACT_INFO = {
  office: ['19 Orchid Avenue', 'Surfers Paradise QLD 4217', 'Australia'],
  postal: ['PO Box 1623', 'Surfers Paradise QLD 4217', 'Australia'],
  abn: 'ABN 11 104 845 847',
  acn: 'ACN 104 845 847',
};

export const CONTACT_REASONS = [
  'Investment Opportunity',
  'Business Proposal',
  'General Enquiry',
  'Media / Interview Request',
  'Partnership',
];

export const CONTACT_SECTORS = [
  'Venture Capital',
  'Information Technology',
  'Gaming',
  'Property',
  'Entertainment',
  'General / Other',
];

// ---- Sector detail pages ----
export const SECTOR_PAGES = {
  'information-technology': {
    seoName: 'Technology',
    titleWhite: 'INFORMATION',
    titleGold: ['TECHNOLOGY'],
    heroImg: 'itHero',
    lead: 'Investing in innovative technologies that create global opportunities.',
    sub: 'DIG operates a specialist Technology Investment division, combining global products with local knowledge.',
    two: {
      heading: 'A PROVEN TRACK RECORD IN TECHNOLOGY INVESTMENTS',
      paras: [
        'Our Executive Chairman has brought to market an extensive range of impressive and successful technologies since 1999.',
        'He has a wealth of knowledge and experience in developing technologies, driving the growth and sales of the same and successfully conducting an IPO on the Australian Stock Exchange — which has ultimately lead to the technologies being sold in over 22 countries around the world.',
      ],
      button: null,
      img: 'itContent',
    },
    focus: null,
    feature: {
      title: 'CURRENT TECHNOLOGY INVESTMENTS',
      logo: 'prwebLogo',
      logoText: 'PRWeb',
      logoTag: 'Private Media for the Web',
      paras: [
        "PRWeb is quickly gaining recognition as Australia's premium technology research, development, hosting and Internet marketing company.",
        'Having recently been acquired by Duffy Investment Group via a multi million dollar technology research and development agreement, PRWeb represents a key part of our technology investment portfolio.',
      ],
      button: { label: 'LEARN MORE ABOUT PRWEB', to: '/contact?sector=Information%20Technology' },
    },
    strip: {
      style: 'detailed',
      items: [
        { icon: 'Globe', title: 'GLOBAL REACH', desc: 'Technologies deployed in over 22 countries worldwide.' },
        { icon: 'BarChart3', title: 'PROVEN RESULTS', desc: 'Successful development, growth and commercialisation of technology businesses.' },
        { icon: 'Lightbulb', title: 'INNOVATION FOCUS', desc: 'Backing forward-thinking entrepreneurs and transformative ideas.' },
        { icon: 'Users', title: 'LOCAL EXPERTISE', desc: 'Combining international opportunities with on-the-ground knowledge.' },
      ],
    },
    bandButton: 'OUR INVESTMENT APPROACH',
  },

  'gaming': {
    seoName: 'Gaming',
    titleWhite: 'GAMING',
    titleGold: ['BET THE FLOP'],
    heroImg: 'gamingHero',
    lead: "An innovative side bet game for one of the world's most popular pastimes – Poker.",
    sub: 'Bet the Flop is designed to enhance casino revenue while giving poker players a new, exciting and rewarding experience.',
    two: {
      heading: 'A NEW WAY TO PLAY. A SMARTER WAY TO GROW.',
      paras: [
        'DIG has developed an exciting new casino game called "Bet the Flop". It\'s a side bet game for one of the world\'s oldest and most popular pastimes, POKER.',
        "With a patent recently having been awarded for the Australian casino market and with patent pending in over 100 countries, it is designed to enhance any casino's bottom line whilst providing the casino's poker playing customers a new, exciting and rewarding experience never before available.",
      ],
      button: { label: 'LEARN MORE ABOUT BET THE FLOP', to: '/contact?sector=Gaming' },
      img: 'gamingContent',
    },
    focus: {
      title: 'HOW BET THE FLOP WORKS',
      mobileTitle: 'KEY BENEFITS',
      circleIcons: false,
      cols: [
        { icon: 'WalletCards', title: 'PLAYED ALONGSIDE TRADITIONAL POKER', text: "Designed as a side bet between the player and the house on the 'flop' in a traditional game of Texas Hold'em or Omaha Poker." },
        { icon: 'BarChart3', title: 'INCREASED REVENUE OPPORTUNITY', text: 'Offers a unique addition to any poker room and allows the casino to generate additional revenue.' },
        { icon: 'Cog', title: 'EASY TO IMPLEMENT', text: 'No need for extra floor space or complicated systems. It integrates seamlessly with existing poker games.' },
        { icon: 'Users', title: 'ENHANCED PLAYER EXPERIENCE', text: 'Gives poker players a new, exciting and rewarding side game without the hassle of learning an entirely new game.' },
      ],
    },
    feature: null,
    strip: {
      style: 'detailed',
      items: [
        { icon: 'Globe', title: 'AUSTRALIAN PATENT', desc: 'Patent awarded for the Australian casino market.' },
        { icon: 'FileText', title: 'GLOBAL OPPORTUNITY', desc: 'Patent pending in over 100 countries.' },
        { icon: 'BarChart3', title: 'GROWTH POTENTIAL', desc: 'Designed to enhance casino bottom lines.' },
        { icon: 'Gem', title: 'PROVEN APPEAL', desc: "Adds excitement to one of the world's most popular games." },
      ],
    },
    bandButton: 'OUR INVESTMENT APPROACH',
  },

  'property': {
    seoName: 'Property',
    titleWhite: 'PROPERTY',
    titleGold: ['STRATEGIC', 'DEVELOPMENTS'],
    heroImg: 'propHero',
    lead: 'Investing in residential and commercial developments, with a focus on creating long-term value.',
    sub: 'DIG invests in residential and commercial developments and is currently undergoing a small scale addition to its commercial property arm by way of expansion of a commercial precinct it owns.',
    two: {
      heading: 'STRATEGIC GROWTH IN PRIME LOCATIONS.',
      paras: [
        'Our property investments focus on quality locations, strong fundamentals and developments that deliver long-term value. By expanding our existing commercial precinct, we are building on a solid foundation and creating new opportunities for sustainable growth.',
      ],
      button: { label: 'OUR INVESTMENT APPROACH', to: '/our-investments' },
      img: 'propContent',
    },
    focus: {
      title: 'OUR PROPERTY FOCUS',
      circleIcons: false,
      cols: [
        { icon: 'Home', title: 'RESIDENTIAL DEVELOPMENTS', text: 'Quality living spaces in high-growth areas.', short: 'Quality living spaces in high-growth areas.' },
        { icon: 'Building2', title: 'COMMERCIAL DEVELOPMENTS', text: 'Expanding existing precincts and new opportunities.', short: 'Expanding existing precincts and new opportunities.' },
        { icon: 'BarChart3', title: 'LONG-TERM VALUE', text: 'Strategic investments with sustainable growth potential.', short: 'Strategic investments with sustainable growth potential.' },
        { icon: 'Users', title: 'LOCAL EXPERTISE', text: 'On-the-ground knowledge combined with a global perspective.', short: 'On-the-ground knowledge combined with a global perspective.' },
      ],
    },
    feature: null,
    strip: {
      style: 'compact',
      items: [
        { icon: 'MapPin', l1: 'PRIME', l2: 'LOCATIONS' },
        { icon: 'Building2', l1: 'QUALITY', l2: 'DEVELOPMENTS' },
        { icon: 'BarChart3', l1: 'LONG-TERM', l2: 'GROWTH' },
        { icon: 'Users', l1: 'EXPERIENCED', l2: 'TEAM' },
      ],
    },
    bandSub: 'opportunities',
    bandButton: 'OUR INVESTMENTS',
  },

  'entertainment': {
    seoName: 'Entertainment',
    titleWhite: 'ENTERTAINMENT',
    titleGold: ['ICONIC VENUES.', 'LASTING EXPERIENCES.'],
    heroImg: 'entHero',
    lead: 'Investing in world-class entertainment that brings people together.',
    sub: 'For many years DIG has been successfully involved in the entertainment industry across a range of sectors, including nightclubs, concerts and amusements.',
    two: {
      heading: "AUSTRALIA'S PREMIER NIGHTLIFE DESTINATION.",
      paras: [
        "Through strategic investment, hands-on involvement and a commitment to delivering exceptional experiences, DIG has established and operated some of Australia's most iconic entertainment venues.",
        'From exclusive nightclubs to international concerts and major amusement investments, our entertainment portfolio is built on creating memorable experiences and long-term value.',
      ],
      button: { label: 'OUR INVESTMENT APPROACH', to: '/our-investments' },
      img: 'entContent',
    },
    focus: {
      title: 'OUR ENTERTAINMENT FOCUS',
      circleIcons: true,
      img: 'entFocus',
      cols: [
        { icon: 'Martini', title: 'NIGHTCLUBS', text: "Starting, operating, designing and building a total of five clubs since 2003 via multi-million dollar investments in some of Australia's most iconic venues.", short: 'Iconic venues since 2003.' },
        { icon: 'Mic', title: 'CONCERTS', text: 'Via its extensive international network in the entertainment capital of the World, Las Vegas, DIG has successfully financed and toured international acts all over Australia.', short: 'International acts all over Australia.' },
        { icon: 'FerrisWheel', title: 'AMUSEMENTS', text: "One of DIG founder's early investments, lead it to become one of Australia's largest Amusement companies of its type.", short: "One of Australia's largest." },
      ],
    },
    feature: null,
    strip: {
      style: 'compact',
      items: [
        { icon: 'Martini', l1: 'ICONIC', l2: 'VENUES' },
        { icon: 'Mic', l1: 'INTERNATIONAL', l2: 'ARTISTS' },
        { icon: 'Users', l1: 'LEADING', l2: 'OPERATOR' },
        { icon: 'Gem', l1: 'MEMORABLE', l2: 'EXPERIENCES' },
      ],
    },
    bandButton: 'OUR INVESTMENTS',
  },
};

export const OPPORTUNITIES = [
  'Experienced nightclub managers',
  'Retail clothing sales & management experts',
  'Great investment opportunities',
  'Sales & marketing experts',
  'I.T developers',
];
